import React from 'react';
import styles from './ChatHeader.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const ChatHeader = ({ handleExpand, isExpanded, isWorkflow }) => {
  return (
    <div
      className={`${styles['chat-header']} ${
        isExpanded ? styles['expand'] : styles['collapse']
      } ${isWorkflow ? styles['workflow'] : ''}`}
      onClick={handleExpand}
    >
      <div className={styles['navigation-container']}>
        <div
          className={`${styles['navigation']} ${
            isExpanded ? styles['expand'] : styles['collapse']
          }`}
        >
          <div className={styles['left-container']}>
            <SvgWithBranding type="flow" />
            <p>Workflows</p>
          </div>
          <SvgWithBranding type="chat-bart" />
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
